module.exports = {"id":"189805","name":"Luuk de Jong","rating":"77","photo":"./data/images/photos/3/189805.png","club":{"name":"PSV","logo":"./data/images/clubs/PSV.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LuukdeJong0.json
// module id = 2646
// module chunks = 0